import { useEffect } from 'react';

import { useTabContentConfig } from '../components/PageConfigProvider/PageConfigProvider';
import { usePageState } from '../components/PageState/PageStateProvider';
import { usePrimaryFilterState } from '../filters/hooks/usePrimaryFilterState';

export const useSyncPrimaryEntities = () => {
  const { pageState, dispatch: pageDispatch } = usePageState();
  const { config, primaryFilter: tabPrimaryFilter } = useTabContentConfig();
  const { primaryFilter } = usePrimaryFilterState(tabPrimaryFilter?.id);

  const selections = primaryFilter?.selections;

  useEffect(() => {
    const validSelectionIds = new Set(
      selections?.map((s) => s.id.split('_').pop() ?? s.id) ?? []
    );

    const plotIdsToClear = Object.entries(pageState.primaryEntities)
      .filter(([itemId, entity]) => {
        const itemInConfig = config.items.some((item) => item.id === itemId);
        if (!itemInConfig) return true;
        if (entity && validSelectionIds.size > 0) {
          return !validSelectionIds.has(entity.id);
        }
        return false;
      })
      .map(([itemId]) => itemId);

    if (plotIdsToClear.length > 0) {
      pageDispatch({
        type: 'CLEAR_PRIMARY_ENTITIES',
        payload: { plotIds: plotIdsToClear },
      });
    }
  }, [pageState.primaryEntities, config.items, selections, pageDispatch]);
};
